import { request } from "../utils/request";

const departApi = {
  // 获取科室列表
  getDepartList(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageSection/manageSection",
      data
    });
  },
  // 添加科室
  createSection(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageSection/createSection",
      data
    });
  },
  // 编辑科室
  edit(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageSection/edit",
      data
    });
  },
  // 删除科室
  deleteSection(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageSection/deleteSection",
      data
    });
  },
  // 批量删除科室
  deleteSectionBatch(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageSection/deleteSectionBatch",
      data
    });
  },
  // 获取职称列表
  getPTitleList(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageStudent/getPTitleEnum",
      data
    });
  },
  // 获取职位列表
  getPositionList(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageStudent/getPosition",
      data
    });
  },
  // 获取科室考生列表
  getDeptStudentList(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/SectionStudentDetail/getDeptStudentList",
      data
    });
  },
  // 查询组管理列表
  groupList(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/groupManage/groupList",
      data
    });
  },
  // 添加考生列表
  getStudentList(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageStudent/getStudentList",
      data
    });
  },
  // 添加考生确定按钮
  addStudent(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageStudent/addStudent",
      data
    });
  },
  // 修改考生确定按钮
  modifyStudentInfo(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageStudent/modifyStudentInfo",
      data
    });
  },
  // 删除考生
  deleteStudent(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/deleteStudent_dep/deleteStudent",
      data
    });
  },
  // 批量删除考生
  deleteStudentBatch(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/deleteStudent_dep/deleteStudentBatch",
      data
    });
  },
  // 上移下移 
  switchManageSection(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageSection/switchManageSection",
      data
    });
  },
  // 科室变更列表
  departmentWaitList(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageSection/departmentWaitList",
      data
    });
  },
  // 处理更换科室申请  
  updateWaitDepartment(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageSection/updateWaitDepartment",
      data
    });
  }
};

export default departApi;
